import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class VendorQuotation {
  async fetch(page, pageSize, search) {
    const pageParam = `page=${page}&perPage=${pageSize}`
    let params = search ? `search=${search}` : pageParam;

    const response = await ajaxService.get(`/vendors-quotations?${params}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async viewQuotation(id) {
    const response = await ajaxService.get(`/vendors-quotations/${id}`);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async addQuotation(data) {
    const response = await ajaxService.post(`/vendors-quotations`, data);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async updateQuotation(id, data) {
    const response = await ajaxService.put(`/vendors-quotations/`, id, data);
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async deleteQuotation(id) {
    const response = await ajaxService.delete(`/vendors-quotations/`, id);
    if (response ?? false) {
      return response;
    }
  }
}

const vendorQuotation = new VendorQuotation();
export default vendorQuotation;
